// Minimal RFC 4180 CSV reader/writer (quoted fields, escaped quotes, CRLF/LF),
// shared by the import API and the web export.
export function parseCsv(text) {
    const rows = [];
    let row = [];
    let field = '';
    let quoted = false;
    const s = text.charCodeAt(0) === 0xfeff ? text.slice(1) : text; // strip BOM
    for (let i = 0; i < s.length; i++) {
        const c = s[i];
        if (quoted) {
            if (c === '"') {
                if (s[i + 1] === '"') {
                    field += '"';
                    i++;
                }
                else
                    quoted = false;
            }
            else
                field += c;
        }
        else if (c === '"' && field === '')
            quoted = true;
        else if (c === ',') {
            row.push(field);
            field = '';
        }
        else if (c === '\n' || c === '\r') {
            if (c === '\r' && s[i + 1] === '\n')
                i++;
            row.push(field);
            field = '';
            if (row.some((f) => f !== ''))
                rows.push(row);
            row = [];
        }
        else
            field += c;
    }
    row.push(field);
    if (row.some((f) => f !== ''))
        rows.push(row);
    return rows;
}
/** Parses CSV with a header row into objects keyed by lower-cased header. */
export function csvRecords(text) {
    const [head, ...body] = parseCsv(text);
    const headers = (head ?? []).map((h) => h.trim().toLowerCase());
    const records = body.map((r) => Object.fromEntries(headers.map((h, i) => [h, (r[i] ?? '').trim()])));
    return { headers, records };
}
function cell(v) {
    if (v === null || v === undefined)
        return '';
    const s = typeof v === 'string'
        ? v
        : typeof v === 'number' || typeof v === 'boolean'
            ? String(v)
            : JSON.stringify(v);
    // Neutralise spreadsheet formula injection (OWASP CSV injection).
    const safe = /^[=+\-@\t\r]/.test(s) && !/^-?\d+(\.\d+)?$/.test(s) ? `'${s}` : s;
    return /[",\n\r]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
}
export function toCsv(headers, rows) {
    return ([headers.map(cell).join(','), ...rows.map((r) => r.map(cell).join(','))].join('\r\n') + '\r\n');
}
export const truthy = (v) => /^(y|yes|true|1|x)$/i.test((v ?? '').trim());
//# sourceMappingURL=csv.js.map